// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"afa2f1a3","213":"2ab6941b","453":"fdda853a","455":"d80157e5","524":"e17dae8d","756":"103c396b"}[chunkId] + ".chunk.js";
};